import './setup';

import {
  feedbackIntegration,
  init,
  reactRouterV6BrowserTracingIntegration,
  replayIntegration,
  setTags,
} from '@sentry/react';
import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { App } from './app';

async function main() {
  if (runtimeEnv.SENTRY_ENABLED) {
    // https://docs.sentry.io/platforms/javascript/guides/react/#configure

    const integrations = [
      reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      replayIntegration(),
    ];

    if (runtimeEnv.SENTRY_FEEDBACK_ENABLED) {
      integrations.push(
        feedbackIntegration({
          colorScheme: 'system',
          triggerLabel: '',
          triggerAriaLabel: '',
          formTitle: 'Отчет о проблеме',
          nameLabel: 'Имя',
          confirmButtonLabel: 'Подтвердить',
          namePlaceholder: 'Напишите имя',
          emailPlaceholder: 'Напишите email',
          messageLabel: 'Описание проблемы',
          isNameRequired: true,
          messagePlaceholder: 'Напишите описание проблемы',
          isRequiredLabel: '*',
          addScreenshotButtonLabel: 'Добавить screenshot',
          removeScreenshotButtonLabel: 'Удалить screenshot',
          submitButtonLabel: 'Отправить отчет о проблеме',
          cancelButtonLabel: 'Отмена',
          successMessageText: 'Спасибо за ваш отчет',
        })
      );
    }

    init({
      dsn: runtimeEnv.SENTRY_DSN,
      environment: runtimeEnv.DNB_APP_BUILD_TYPE ?? 'development',
      release: runtimeEnv.SENTRY_RELEASE,
      integrations,
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
    setTags({
      appVersion: BUILD_CONFIG.appVersion,
      editorVersion: BUILD_CONFIG.editorVersion,
    });
  }

  mountApp();
}

function mountApp() {
  const root = document.getElementById('app')!;
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

try {
  main().catch(err => console.error('Failed to bootstrap app', err));
} catch (err) {
  console.error('Failed to bootstrap app', err);
}
